import { makeStyles } from '@mui/styles';
import { LYNKED_RED, LYNKED_WHITE } from '../../consts/colors';

const useStyles = makeStyles(() => ({
  dialog_background: {
    backgroundColor: LYNKED_RED,
    color: LYNKED_WHITE,
    '& div svg path': {
      fill: LYNKED_WHITE,
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: '700',
  },
}));

const buttonStyle = {
  display: 'flex',
  padding: '10px 16px',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '8px',
  alignSelf: 'stretch',
  background: LYNKED_RED,
  '&:hover': { backgroundColor: LYNKED_RED },
  boxShadow: 'none',
};

export { useStyles, buttonStyle };
